export function toSlug(key) {
  return key
    .toLowerCase()
    .replace(/[\s-–]+/g, "_")
    .replace(/[.,]/g, "")
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_");
}
